declare global {
  interface Window {
    WHITE_BOT_CONFIG?: Partial<RuntimeConfig>;
  }
}

export interface RuntimeConfig {
  apiMode: 'mock' | 'local' | 'supabase';
  localApiUrl: string;
  supabaseUrl: string;
  supabaseAnonKey: string;
  allowCommands: boolean;
  allowedCommandSlotKeys: string[];
}

export function runtimeConfig(): RuntimeConfig {
  const windowConfig = window.WHITE_BOT_CONFIG || {};
  const allowedCommandSlotKeys =
    windowConfig.allowedCommandSlotKeys ||
    String(import.meta.env.VITE_ALLOWED_COMMAND_SLOT_KEYS || '')
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);
  return {
    apiMode: windowConfig.apiMode || import.meta.env.VITE_API_MODE || 'mock',
    localApiUrl: windowConfig.localApiUrl || import.meta.env.VITE_LOCAL_API_URL || 'http://127.0.0.1:8765',
    supabaseUrl: windowConfig.supabaseUrl || import.meta.env.VITE_SUPABASE_URL || '',
    supabaseAnonKey: windowConfig.supabaseAnonKey || import.meta.env.VITE_SUPABASE_ANON_KEY || '',
    allowCommands:
      windowConfig.allowCommands ??
      String(import.meta.env.VITE_ALLOW_COMMANDS || '').toLowerCase() === 'true',
    allowedCommandSlotKeys
  };
}
